/**
 * @generated SignedSource<<94e66f0e14dca39248723e32c402bca3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AgendaMemberNoteStatus = "HIGH" | "MEDIUM" | "STANDARD";
export type MultiSlotAgendaEventsQuery$variables = {
  date: string;
  facilityId: string;
  memberId: string;
  requestConfigs: boolean;
};
export type MultiSlotAgendaEventsQuery$data = {
  readonly node: {
    readonly __typename: string;
    readonly agendas?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly configuredRequestRestrictions?: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
              } | null | undefined;
              readonly requestCloses: string | null | undefined;
              readonly requestOpens: string | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly date: string;
          readonly id: string;
          readonly memberNote: {
            readonly body: string;
            readonly header: string;
            readonly id: string;
            readonly status: AgendaMemberNoteStatus;
          } | null | undefined;
          readonly queueSlot: {
            readonly id: string;
          };
          readonly requestRestrictions?: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"agendaEventNodesByIdAtom_events">;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly id: string;
  } | null | undefined;
};
export type MultiSlotAgendaEventsQuery = {
  response: MultiSlotAgendaEventsQuery$data;
  variables: MultiSlotAgendaEventsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "facilityId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requestConfigs"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "facilityId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "dateGte",
    "variableName": "date"
  },
  {
    "kind": "Variable",
    "name": "dateLte",
    "variableName": "date"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v9 = [
  (v5/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "QueueSlot",
  "kind": "LinkedField",
  "name": "queueSlot",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v11 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": [
      "REQUEST"
    ]
  }
],
v12 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestOpens",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestCloses",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "AgendaMemberNote",
  "kind": "LinkedField",
  "name": "memberNote",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "header",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    (v15/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v18 = [
  {
    "kind": "Variable",
    "name": "clientId",
    "variableName": "memberId"
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MultiSlotAgendaEventsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "AgendaConnection",
                "kind": "LinkedField",
                "name": "agendas",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgendaEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agenda",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v5/*: any*/),
                          (v10/*: any*/),
                          {
                            "condition": "requestConfigs",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                              {
                                "alias": "requestRestrictions",
                                "args": (v11/*: any*/),
                                "concreteType": "AgendaBookingRulesConnection",
                                "kind": "LinkedField",
                                "name": "bookingRules",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AgendaBookingRulesEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      (v12/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "bookingRules(type:[\"REQUEST\"])"
                              }
                            ]
                          },
                          {
                            "condition": "requestConfigs",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": "configuredRequestRestrictions",
                                "args": (v11/*: any*/),
                                "concreteType": "AgendaBookingRulesConnection",
                                "kind": "LinkedField",
                                "name": "requestWindowBookingRules",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AgendaBookingRulesEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v14/*: any*/),
                                      (v12/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
                              }
                            ]
                          },
                          (v16/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "agendaEventNodesByIdAtom_events"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Facility",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "MultiSlotAgendaEventsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "AgendaConnection",
                "kind": "LinkedField",
                "name": "agendas",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgendaEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agenda",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v5/*: any*/),
                          (v10/*: any*/),
                          {
                            "condition": "requestConfigs",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                              {
                                "alias": "requestRestrictions",
                                "args": (v11/*: any*/),
                                "concreteType": "AgendaBookingRulesConnection",
                                "kind": "LinkedField",
                                "name": "bookingRules",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AgendaBookingRulesEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      (v17/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "bookingRules(type:[\"REQUEST\"])"
                              }
                            ]
                          },
                          {
                            "condition": "requestConfigs",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": "configuredRequestRestrictions",
                                "args": (v11/*: any*/),
                                "concreteType": "AgendaBookingRulesConnection",
                                "kind": "LinkedField",
                                "name": "requestWindowBookingRules",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AgendaBookingRulesEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v14/*: any*/),
                                      (v17/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
                              }
                            ]
                          },
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventConnection",
                            "kind": "LinkedField",
                            "name": "events",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Event",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      {
                                        "alias": null,
                                        "args": (v18/*: any*/),
                                        "kind": "ScalarField",
                                        "name": "accessStatusForClient",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": (v18/*: any*/),
                                        "kind": "ScalarField",
                                        "name": "signUpStatusForClient",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": (v18/*: any*/),
                                        "concreteType": "EventSignUp",
                                        "kind": "LinkedField",
                                        "name": "signUpForClient",
                                        "plural": false,
                                        "selections": [
                                          (v15/*: any*/),
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "accessStatus",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "capacity",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "spotsAvailable",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "hasWaitlist",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventSeries",
                                        "kind": "LinkedField",
                                        "name": "eventSeries",
                                        "plural": false,
                                        "selections": [
                                          (v19/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "color",
                                            "storageKey": null
                                          },
                                          (v5/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "EventConnection",
                                            "kind": "LinkedField",
                                            "name": "events",
                                            "plural": false,
                                            "selections": [
                                              (v20/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "recurrenceIndex",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventSessionConnection",
                                        "kind": "LinkedField",
                                        "name": "eventSessions",
                                        "plural": false,
                                        "selections": [
                                          (v20/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "EventSessionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "EventSession",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "durationMins",
                                                    "storageKey": null
                                                  },
                                                  (v19/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "startAt",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "endAt",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "StaffProfileConnection",
                                        "kind": "LinkedField",
                                        "name": "hosts",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "StaffProfileEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "StaffProfile",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "StaffUser",
                                                    "kind": "LinkedField",
                                                    "name": "user",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "fullName",
                                                        "storageKey": null
                                                      },
                                                      (v5/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v5/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": (v18/*: any*/),
                                        "concreteType": "EventSignUpWindow",
                                        "kind": "LinkedField",
                                        "name": "clientEligibleSignUpWindows",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "opensAt",
                                            "storageKey": null
                                          },
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Facility",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "56c475b016173ce450076154922089fc",
    "id": null,
    "metadata": {},
    "name": "MultiSlotAgendaEventsQuery",
    "operationKind": "query",
    "text": "query MultiSlotAgendaEventsQuery(\n  $facilityId: ID!\n  $date: Date!\n  $memberId: ID!\n  $requestConfigs: Boolean!\n) {\n  node(id: $facilityId) {\n    id\n    __typename\n    ... on Facility {\n      id\n      agendas(dateGte: $date, dateLte: $date) {\n        edges {\n          node {\n            date\n            id\n            queueSlot {\n              id\n            }\n            requestRestrictions: bookingRules(type: [REQUEST]) @skip(if: $requestConfigs) {\n              edges {\n                node {\n                  __typename\n                  id\n                }\n              }\n            }\n            configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST]) @include(if: $requestConfigs) {\n              edges {\n                requestOpens\n                requestCloses\n                node {\n                  __typename\n                  id\n                }\n              }\n            }\n            memberNote {\n              id\n              header\n              body\n              status\n            }\n            ...agendaEventNodesByIdAtom_events\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventSlot_event on Event {\n  id\n  accessStatusForClient(clientId: $memberId)\n  signUpStatusForClient(clientId: $memberId)\n  signUpForClient(clientId: $memberId) {\n    status\n    id\n  }\n  accessStatus\n  capacity\n  spotsAvailable\n  hasWaitlist\n  eventSeries {\n    name\n    color\n    id\n    events {\n      count\n    }\n  }\n  recurrenceIndex\n  eventSessions {\n    count\n    edges {\n      node {\n        id\n        durationMins\n        name\n        startAt\n        endAt\n      }\n    }\n  }\n  hosts {\n    edges {\n      node {\n        user {\n          fullName\n          id\n        }\n        id\n      }\n    }\n  }\n  clientEligibleSignUpWindows(clientId: $memberId) {\n    opensAt\n    id\n  }\n}\n\nfragment agendaEventNodesByIdAtom_events on Agenda {\n  events {\n    edges {\n      node {\n        id\n        ...EventSlot_event\n        eventSessions {\n          edges {\n            node {\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b1e23bf9934c2b3818cd42f03457495c";

export default node;
